module.exports = __webpack_public_path__ + "img/arrow_1_Color.6353d62c.svg";